import { supabase } from '../supabase';
import { ChatConversation } from '../types';

const TABLE = 'ai_conversations';

export async function createConversation(
    userId: string,
    stream: string,
    subject: string,
    firstMessage: string,
    pdfFileName?: string
): Promise<string> {
    const title = firstMessage.length > 50 ? firstMessage.slice(0, 50) + '...' : firstMessage;
    const { data, error } = await supabase.from(TABLE).insert({
        user_id: userId,
        stream,
        subject,
        title,
        messages: [],
        pdf_file_name: pdfFileName ?? null,
    }).select('id').single();
    if (error) throw error;
    return data.id;
}

export async function addMessages(
    conversationId: string,
    userMessage: string,
    modelResponse: string
): Promise<void> {
    // Fetch current messages first
    const { data: conv, error: fetchErr } = await supabase.from(TABLE).select('messages').eq('id', conversationId).single();
    if (fetchErr || !conv) return;

    const now = new Date().toISOString();
    const messages = [
        ...(conv.messages || []),
        { role: 'user', text: userMessage, timestamp: now },
        { role: 'model', text: modelResponse, timestamp: now },
    ];

    const { error } = await supabase.from(TABLE).update({
        messages,
        last_message_at: now,
    }).eq('id', conversationId);
    if (error) throw error;
}

export async function getConversations(userId: string): Promise<ChatConversation[]> {
    const { data, error } = await supabase.from(TABLE)
        .select('*')
        .eq('user_id', userId)
        .order('last_message_at', { ascending: false });
    if (error) throw error;
    return (data || []) as ChatConversation[];
}

export async function getConversation(conversationId: string): Promise<ChatConversation | null> {
    const { data, error } = await supabase.from(TABLE).select('*').eq('id', conversationId).single();
    if (error || !data) return null;
    return data as ChatConversation;
}

export async function deleteConversation(conversationId: string): Promise<void> {
    const { error } = await supabase.from(TABLE).delete().eq('id', conversationId);
    if (error) throw error;
}
